import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { CSS } from './styles.js';
import Navbar from './components/Navbar.jsx';
import Footer from './components/Footer.jsx';

/**
 * MarketingLayout
 * Wrapper per tutte le pagine del sito marketing integrate nell'app CRA.
 * - Inietta il CSS del marketing via <style> (scoped alla sola presenza del
 *   layout nella pagina — viene rimosso quando si naviga al gestionale).
 * - Mostra Navbar e Footer del marketing.
 * - Fa scroll to top ad ogni cambio di rotta.
 */
export default function MarketingLayout({ children }) {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [pathname]);

  return (
    <>
      {/* CSS del marketing iniettato globalmente solo quando il layout è montato */}
      <style dangerouslySetInnerHTML={{ __html: CSS }} />
      <Navbar />
      <main style={{ paddingTop: '62px' }}>{children}</main>
      <Footer />
    </>
  );
}
